/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var search_triggers = document.querySelectorAll('.search-trigger'),
      search_modal_container = document.getElementById('search-modal-container'),
      search_modal = document.getElementById('search-modal'),
      modal_close = search_modal_container.querySelector('.modal-close'),
      opened_trigger = false;

  if(search_triggers) {
    search_triggers.forEach((search_trigger) => {
      search_trigger.addEventListener('click', (e) => {
        e.preventDefault();
        document.body.classList.add('modal-open');
        search_modal_container.classList.add('open');
        opened_trigger = e.target;

        setTimeout(function() {
          if(search_modal_container.classList.contains('open')) {
            search_modal.querySelector('input').focus();
          }
        }, 500);
      });
    });
  }

  search_modal_container.addEventListener('click', (e) => {
    close_search_modal();
  });

  search_modal_container.addEventListener('keydown', function(e) {
    if(e.code === 'Escape') {
      e.preventDefault();

      close_search_modal();
    }
  });

  trapFocus(search_modal);

  search_modal.addEventListener('click', (e) => {
    e.stopPropagation();

    // Stopping this event here so the container event doesn't trigger and close the modal
  });

  modal_close.addEventListener('click', (e) => {
    e.preventDefault();

    close_search_modal();
  });

  function close_search_modal() {
    document.body.classList.remove('modal-open');
    search_modal_container.classList.remove('open');

    if(opened_trigger) {
      opened_trigger.focus();
      opened_trigger = false;
    }
  }
}());